



















import Vue from "vue";
import { Component } from "vue-property-decorator";
import { Getter, Mutation, namespace } from "vuex-class";

const appStore = namespace("app");

@Component({
  name: "Alert"
})
export default class Alert extends Vue {
  @appStore.Getter app_alert: any;
  @appStore.Mutation removeAlert: any;
}
